import { ArrowLeft } from "lucide-react";
import { useEffect } from "react";
import { Link } from "wouter";

type ComingSoonProps = {
  title: string;
};

export default function ComingSoon({ title }: ComingSoonProps) {
  useEffect(() => {
    document.title = `${title} | Daily Groove`;
  }, [title]);

  return (
    <main className="coming-soon-page">
      <section className="coming-soon-content">
        <p className="coming-soon-label">Daily Groove</p>
        <h1>{title}</h1>
        <p className="coming-soon-message">Coming soon.</p>
        <Link className="coming-soon-link" href="/">
          <ArrowLeft aria-hidden="true" />
          Dashboard
        </Link>
      </section>
    </main>
  );
}

export function NotesComingSoon() {
  return <ComingSoon title="Notes" />;
}

export function SearchComingSoon() {
  return <ComingSoon title="Search" />;
}
